import { QuickActionsMoreMenu as e } from "./components/QuickActionsMoreMenu.mjs";
import { QuickActionTile as t } from "./components/QuickActionTile.mjs";
import { Widget as n } from "../Widget/Widget.mjs";
import { ActionsGrid as r } from "./styled/QuickActions.styled.mjs";
import "react";
import { useTranslation as i } from "@maat/store-i18n";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/QuickActions/QuickActions.tsx
var s = ({ actions: s, title: c, maxVisible: l = 4, columns: u = 4, className: d }) => {
	let { t: f } = i("ds"), p = s.slice(0, l), m = s.slice(l);
	return /* @__PURE__ */ o(n, {
		className: d,
		children: [/* @__PURE__ */ a(n.Header, {
			title: c ?? f("ds:quickActions.title"),
			action: m.length > 0 ? /* @__PURE__ */ a(e, { actions: m }) : void 0
		}), /* @__PURE__ */ a(n.Content, { children: /* @__PURE__ */ a(r, {
			$columns: Math.min(u, p.length) || 1,
			children: p.map((e) => /* @__PURE__ */ a(t, { action: e }, e.id))
		}) })]
	});
};
//#endregion
export { s as QuickActions };
